import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { SWIPER_CONFIG } from 'js/config/swiper';

// Instantiate
const swiperElements = Array.from(document.querySelectorAll('.swiper'));

const initSwiper = (element) => {
    return new Swiper(element, {
        ...SWIPER_CONFIG,
        modules: [Navigation, Pagination, Autoplay],

        // Vanilla JS config
        ...{
            navigation: {
                nextEl: `#${element.id}-next`,
                prevEl: `#${element.id}-prev`
            },
            pagination: {
                el: `#${element.id}-pagination`,
                clickable: true,
                dynamicBullets: true
            }
        },
        ...(
            JSON.parse(element.dataset?.config || '{}')
        )
    });
}

swiperElements.forEach((element) => {
    initSwiper(element);
});
